import { useFeatureValue } from '@growthbook/growthbook-react';
import { Box } from '@mui/material';

import { SingleSelectDropdown } from '@/components';
import {
  AllOption,
  ComplianceTypes,
  EpisodeFilterDefaults,
  SortByOptionsNasba,
  SortByOptionsNonNasba,
} from '@/constants';
import {
  selectUserCompliance,
  useAppSelector,
  useFetchEpisodeFacetsQuery,
} from '@/store';
import { LibraryFilters } from '@/types';
import { getFacetOptions } from '@/utils';

interface FacetSelectorsProps {
  filters: LibraryFilters | null;
  onFilter: (filters: LibraryFilters) => void;
}

export const FacetSelectors = ({ filters, onFilter }: FacetSelectorsProps) => {
  const isAudienceFunctionEnabled = useFeatureValue(
    'audience-function-select',
    false,
  );

  const compliance = useAppSelector(selectUserCompliance);
  const isCPE = compliance === ComplianceTypes.CPE;

  // TODO: Make this a bit more dynamic and less hardcoded?
  const { data: facets } = useFetchEpisodeFacetsQuery();
  const mediaTypeFacet = facets?.entities['media_type'];
  const audienceFunctionFacet = facets?.entities['audience_function'];

  if (!filters) return null;

  return (
    <Box sx={{ display: 'flex' }}>
      {!!isAudienceFunctionEnabled &&
      !!audienceFunctionFacet &&
      !!filters.audienceFunction ? (
        <Box sx={styles.filterBox}>
          <SingleSelectDropdown
            selectedOption={filters.audienceFunction?.[0]}
            options={{
              [AllOption.key]: AllOption,
              ...getFacetOptions(audienceFunctionFacet),
            }}
            onSave={value =>
              onFilter({
                ...filters,
                audienceFunction: [value],
              })
            }
            title={'Function: '}
          />
        </Box>
      ) : null}
      {!!mediaTypeFacet && !!filters.mediaType ? (
        <Box sx={styles.filterBox}>
          <SingleSelectDropdown
            selectedOption={filters.mediaType?.[0]}
            options={{
              [AllOption.key]: AllOption,
              ...getFacetOptions(mediaTypeFacet),
            }}
            onSave={value =>
              onFilter({
                ...filters,
                mediaType: [value],
              })
            }
            title={`${mediaTypeFacet.name}: `}
          />
        </Box>
      ) : null}
      <Box sx={styles.filterBox}>
        <SingleSelectDropdown
          selectedOption={filters.sortBy?.[0] ?? EpisodeFilterDefaults.sortBy}
          options={isCPE ? SortByOptionsNasba : SortByOptionsNonNasba}
          onSave={value =>
            onFilter({
              ...filters,
              sortBy: [value],
            })
          }
          title="Sort By: "
        />
      </Box>
    </Box>
  );
};

const styles = {
  filterBox: {
    display: 'flex',
    mr: 1.25,
    justifyContent: {
      xs: 'flex-start',
      sm: 'center',
    },
    mt: {
      xs: 1.25,
      sm: 0,
    },
    mb: {
      xs: 0,
      sm: 1.25,
    },
  },
};
